import { PartsMatrixEntry } from '../../sdk'
import { roundToTwoDecimal } from '../roundToTwoDecimal/roundToTwoDecimal'

export const filterMargins = (
  thresholdToMarginPercentage: { [key: string]: number } | undefined,
  cost: number
) => {
  if (!thresholdToMarginPercentage) {
    return 0
  }
  const thresholds: number[] = Object.keys(thresholdToMarginPercentage).map(
    (key: string) => Number(key)
  )
  const margins: number[] = Object.values(thresholdToMarginPercentage)
  let margin = margins[0]
  for (let i = 0; i < margins.length; i++) {
    if (cost >= thresholds[i]) {
      margin = margins[i]
    } else {
      break
    }
  }
  return margin
}

export const filterMarginsFromAllMatrixEntries = (
  markupOptions: PartsMatrixEntry[],
  selectedMarkup: string,
  cost: number
) => {
  const found = markupOptions.filter(
    (markup) => markup.id === selectedMarkup
  )[0]
  if (!found) {
    return 0
  }
  return filterMargins(found.info!.thresholdToMarginPercentage, cost)
}

export const filterMarginsWithEntries = (
  markup: PartsMatrixEntry,
  cost: number
) => {
  const thresholds: number[] = Object.keys(
    markup.info!.thresholdToMarginPercentage!
  ).map((key: string) => Number(key))
  const margins: number[] = Object.values(
    markup.info!.thresholdToMarginPercentage!
  )
  let margin = margins[0]
  for (let i = 0; i < margins.length; i++) {
    if (cost >= thresholds[i]) {
      margin = margins[i]
    } else {
      break
    }
  }
  return margin
}

export const calcMargin = (cost: number, price: number) => {
  return roundToTwoDecimal((1 - cost / price) * 100)
}

export const calcMarkup = (cost: number, price: number) => {
  const margin = calcMargin(cost, price)
  return calcMarkupWithMargin(margin)
}

export function calcMarginWithMarkup(markup: number): number {
  return roundToTwoDecimal((1 - 1 / markup) * 100)
}

export function calcMarkupWithMargin(margin: number): number {
  return roundToTwoDecimal(1 / (1 - margin / 100))
}

export const calcPriceWithMargin = (cost: number, margin: number) => {
  return roundToTwoDecimal((cost / (100 - margin)) * 100)
}

export const calcPriceWithMarkup = (cost: number, markup: number) => {
  const margin = calcMarginWithMarkup(markup)
  return calcPriceWithMargin(cost, margin)
}
